import React, {useEffect} from 'react'

import useScreenLog from '@hook/useScreenLog'
import TokenLandingPageContainer from '@feature/landing/pages/token/TokenLandingPageContainer'
import useTokenLandingStore, {TokenLandingTypes} from '@feature/landing/pages/token/hooks/useTokenLandingStore'
import {getMessages} from '@lib/intl/intl'

const HomePage: React.FC = () => {
    const {} = useScreenLog({pageName: 'home'})
    const {setPageType} = useTokenLandingStore()

    useEffect(() => {
        setPageType(TokenLandingTypes.SERVICE)
    }, [setPageType])
    return <TokenLandingPageContainer />
}

export const getStaticProps = async ({locale}) => ({
    props: {
        messages: await getMessages(locale),
    },
})

export default HomePage
